import { FileCard, MediaBrowser } from '@readcloud/component-library';
import { Book, Tag } from '@readcloud/data';
import React, { useEffect, useState } from 'react';
import { checkURLForMediaType, MEDIA_TYPE } from '../helpers/MediaType';
interface IMediaBrowserWrapperProps {
  content?: { mediaContent: Book[]; tagsContent: Tag[] };
  isOpen: boolean;
  onSelect: (
    selection?: React.ComponentPropsWithoutRef<typeof FileCard>
  ) => void;
  toggle: () => void;
  mediaType?: MEDIA_TYPE[];
}

const MediaBrowserWrapper: React.FunctionComponent<
  IMediaBrowserWrapperProps
> = (props) => {
  const [relativeContent, setRelativeContent] = useState<{
    mediaContent: Book[];
    tagContent: Tag[];
  }>();
  const [filteredContent, setFilteredContent] = useState<{
    mediaContent: Book[];
    tagContent: Tag[];
  }>();
  const [formattedContent, setFormattedContent] = useState({});
  const [detailed, setDetailed] = useState(true);

  useEffect(() => {
    const tempMediaContent: Book[] = [];
    const tempTagContent: Tag[] = [];

    if (props.content) {
      props.content.mediaContent &&
        props.content.mediaContent.forEach((media) => {
          if (props.mediaType) {
            const mediaFormat = checkURLForMediaType(media.downloadURI);
            if (
              mediaFormat &&
              props.mediaType.includes(mediaFormat.type as MEDIA_TYPE)
            ) {
              tempMediaContent.push(media);
            }
          } else {
            tempMediaContent.push(media);
          }
        });
      props.content.tagsContent &&
        props.content.tagsContent.forEach((tag) => {
          tempTagContent.push(tag);
        });
    }

    setRelativeContent({
      mediaContent: tempMediaContent,
      tagContent: tempTagContent,
    });

    return () => {
      setRelativeContent(undefined);
    };
  }, []);

  useEffect(() => {
    //do search query logic here.
    setFilteredContent(relativeContent);

    return () => {
      setFilteredContent(undefined);
    };
  }, [relativeContent]);

  const onSelect = (
    selection?: React.ComponentPropsWithoutRef<typeof FileCard>
  ) => {
    props.onSelect(selection);
  };

  useEffect(() => {
    const tempMediaContent: {
      [index: string]: {
        tagName: string;
        data: React.ComponentPropsWithoutRef<typeof FileCard>[];
      };
    } = {};

    tempMediaContent['Untagged'] = { tagName: 'Untagged', data: [] };

    if (!filteredContent || (filteredContent && !filteredContent.mediaContent))
      return;

    //add tags to media.
    filteredContent &&
      filteredContent.mediaContent.forEach((media, i) => {
        filteredContent.tagContent.forEach((tag) => {
          // if the tag has the same book id as the media, push tag name into media tags array.
          tag.bookIds &&
            tag.bookIds.forEach((id) => {
              //if the id's of the media content and the id listed in the tags content array.
              if (id === media.id) {
                //check if media has an array called tags
                if (Array.isArray(filteredContent.mediaContent[i].tags)) {
                  // initialise a flag for checking if the tag already exists.
                  let alreadyExists = false;
                  // foreach tag in the tags array of the piece of media, check if if it matches the tag being checked by comparing the id's
                  filteredContent.mediaContent[i].tags.forEach((mediaTag) => {
                    if (tag.id === mediaTag.id) {
                      alreadyExists = true;
                    }
                  });
                  //if it's made it this far and alreadyExists == false, then push that tag to the tags media array.
                  if (!alreadyExists) {
                    filteredContent.mediaContent[i].tags.push(tag);
                  }
                  // if it doesnt have an array called tags already that means there's no way it has this tag added yet.
                  // we can just initialise the tags array and push our tag to it.
                } else {
                  filteredContent.mediaContent[i].tags = [];
                  filteredContent.mediaContent[i].tags.push(tag);
                }
              }
            });
        });
      });

    //filter media
    filteredContent &&
      filteredContent.mediaContent &&
      filteredContent.mediaContent.forEach((media) => {
        const mediaFormat = checkURLForMediaType(media.downloadURI);
        if (media.tags && media.tags.length) {
          media.tags.forEach((tag) => {
            const { name } = tag;
            if (!tempMediaContent[name]) {
              tempMediaContent[name] = { tagName: name, data: [] };
            }
            tempMediaContent[name].data.push({
              thumbnailUrl: media.imageThumbnailURI
                ? media.imageThumbnailURI
                : '/',
              fileName: media.title,
              fileType: mediaFormat && mediaFormat.format,
              filePath: media.downloadURI,
              created: media.created.toString(),
              fileUploader: media.authorName,
            });
          });
        } else {
          tempMediaContent['Untagged'].data.push({
            thumbnailUrl: media.imageThumbnailURI
              ? media.imageThumbnailURI
              : '/',
            fileName: media.title,
            fileType: mediaFormat && mediaFormat.format,
            filePath: media && media.downloadURI,
            created: media.created.toString(),
            fileUploader: media.authorName,
          });
        }
      });

    setFormattedContent(tempMediaContent);
    return () => {
      setFormattedContent({});
    };
  }, [filteredContent]);

  const onSearch = (query?: string) => {
    // filter relativeContent based on search params.

    setFilteredContent(relativeContent);
  };

  const setMediaDetailed = (detail: boolean) => {
    setDetailed(detail);
  };

  return (
    <MediaBrowser
      onSelect={onSelect}
      onSearch={onSearch}
      toggle={props.toggle}
      isOpen={props.isOpen}
      content={formattedContent}
      fixedNav
      setDetailed={setMediaDetailed}
      detailed={detailed}
    ></MediaBrowser>
  );
};

export default MediaBrowserWrapper;
